module.exports = __webpack_public_path__ + "static/media/PD_05.f88dab00.jpg";